if (!customElements.get('cart-drawer-discount')) {
  class CartDrawerDiscount extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.fetchCartProducts()
        .then(discountSum => {
          this.updateProgressBarVisibility();

          const disabledCurrencies = this.getAttribute('data-disabled-currencies')
            .split(',')
            .map(currency => currency.trim().toUpperCase());

          const shopCurrency = this.getAttribute('data-currency').trim().toUpperCase();

          if (disabledCurrencies.includes(shopCurrency)) {
            this.classList.add('hidden');
            return;
          }

          const shopCurrencySymbol = this.getAttribute('data-currency-symbol');
          let thresholds = this.getThresholdsForCurrency(shopCurrency);

          this.updateDiscountInformation(thresholds, discountSum);

          const progressBar = this.querySelector('.discount-progress__bar');
          if (!progressBar) return;

          this.createProgressBarDots(progressBar, thresholds, discountSum, shopCurrencySymbol);
          this.setProgressBar(thresholds, discountSum);
          this.updateLastDotStyle();
        });
    }

    async fetchCartProducts() {
      const cart = await fetch('/cart.js').then(response => response.json());
      let discountSum = 0;

      for (const item of cart.items) {
        discountSum += item.line_price / 100;
      }

      return discountSum;
    }

    getThresholdsForCurrency(shopCurrency) {
      let thresholds;
      const currentCountry = this.getAttribute('data-current-country');
      
      if (shopCurrency === 'EUR') {
        thresholds = this.getAttribute('data-thresholds-eur').split(',').map(Number);
      } else if (shopCurrency === 'AUD') {
        thresholds = this.getAttribute('data-thresholds-aud').split(',').map(Number);
      } else if (shopCurrency === 'GBP' && currentCountry === 'GB') {
        thresholds = this.getAttribute('data-thresholds-gbp').split(',').map(Number);
      } else if (shopCurrency === 'AED') {
        thresholds = this.getAttribute('data-thresholds-dhs').split(',').map(Number);
      } else {
        thresholds = this.getAttribute('data-thresholds-default').split(',').map(Number);
      }
      
      return thresholds;
    }

    createProgressBarDots(progressBar, thresholds, discountSum, currencySymbol) {
      const maxThreshold = Math.max(...thresholds);

      thresholds.forEach(threshold => {
        let positionPercentage = (threshold / maxThreshold) * 100;
        if (positionPercentage == 100) positionPercentage = 98.7;

        let dot = document.createElement('div');
        dot.innerHTML = '&nbsp;';
        dot.classList.add('discount-progress__dot');
        if (threshold <= discountSum) {
          dot.classList.add('discount-progress__dot--fulfilled');
        }
        dot.style.left = `${positionPercentage}%`;

        progressBar.appendChild(dot);

        const textElement = document.createElement('span');
        textElement.textContent = `${threshold}${currencySymbol}`;
        textElement.style.left = `${positionPercentage - 1}%`;
        textElement.classList.add('discount-progress__text');

        progressBar.appendChild(textElement);
      });
    }

    setProgressBar(thresholds, discountSum) {
      const maxThreshold = Math.max(...thresholds);
      const percentageElement = document.querySelector('.discount-progress__progress');
      let progressPercentage = (discountSum / maxThreshold) * 100;

      percentageElement.style.width = `${Math.min(progressPercentage, 100)}%`;
    }

    updateDiscountInformation(thresholds, discountSum) {
      const discountInfoElement = this.querySelector('#discountInformations');
      const maxDiscountElement = this.querySelector('#maxDiscount');

      if (!discountInfoElement || !maxDiscountElement) {
        console.error('Discount information elements not found');
        return;
      }

      const maxThreshold = Math.max(...thresholds);

      if (discountSum >= maxThreshold) {
        discountInfoElement.classList.add('visually-hidden');
        maxDiscountElement.classList.remove('visually-hidden');
      } else {
        const nextThreshold = thresholds.find(threshold => threshold > discountSum);
        if (nextThreshold) {
          const amountLeft = nextThreshold - discountSum;
          const spanElement = discountInfoElement.querySelector('span');
          if (spanElement) {
            spanElement.textContent = amountLeft.toFixed(2);
          }
          discountInfoElement.classList.remove('visually-hidden');
          maxDiscountElement.classList.add('visually-hidden');
        }
      }
    }

    updateLastDotStyle() {
      const elements = document.querySelectorAll('.discount-progress__text');
      if (elements.length > 0) {
        const lastElement = elements[elements.length - 1];
        lastElement.style.left = 'auto';
        lastElement.style.right = '0';
      }
    }

    updateProgressBarVisibility() {
      let itemsCount = this.getAttribute('data-items-count');

      if (itemsCount == 0) {
        this.classList.add("hidden");
      } else {
        this.classList.remove("hidden");
      }
    }
  }

  customElements.define('cart-drawer-discount', CartDrawerDiscount);
}
